import React from "react"
import * as Ons from "react-onsenui";
import QrScanner from "./QrScanner";

export default class QrPageV2 extends React.Component {
    render() {
        return (
            <>
                <Ons.Page>
                    <QrScanner />
                </Ons.Page>
            </>
        )
    }
}